import { ReactNode } from "react";

interface TablePageBodyProps {
  /** Headline numbers, rendered in one flat fixed block. */
  strip?: ReactNode;
  /** Usually a FilterBar. */
  filters?: ReactNode;
  /** Usually a DataTable, which takes the remaining height. */
  children: ReactNode;
}

/** Body of a table page under PageHeader (DD-042): strip and filters stay put, only the table scrolls. */
export function TablePageBody({ strip, filters, children }: TablePageBodyProps) {
  return (
    <div className="flex-1 min-h-0 flex flex-col gap-3 px-4 lg:px-6 pb-4 lg:pb-6">
      {strip && <div className="shrink-0 bg-white rounded-lg px-4 py-3">{strip}</div>}
      {filters}
      {children}
    </div>
  );
}
